// extracted by mini-css-extract-plugin
module.exports = {"chip":"TypeChip_chip__7EFzJ","icon":"TypeChip_icon__vbeEn","nom":"TypeChip_nom__SAOgS","win":"TypeChip_win__o5jXL","dc":"TypeChip_dc__N9see","mv":"TypeChip_mv__80i7J"};